import { render, staticRenderFns } from "./LackOfSwitch.vue?vue&type=template&id=6d47d534&scoped=true&"
import script from "./LackOfSwitch.vue?vue&type=script&lang=js&"
export * from "./LackOfSwitch.vue?vue&type=script&lang=js&"
import style0 from "./LackOfSwitch.vue?vue&type=style&index=0&id=6d47d534&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d47d534",
  null
  
)

export default component.exports